import { defineMessage } from 'services/localization';

export const messages = {
    confirmationOfPayee: defineMessage('confirmation_of_payee'),
    calculating: defineMessage('calculating'),
    differentBusinessType: defineMessage('the_details_you_have_pr_and_update_if_necessary'),
    differentBusinessName: defineMessage('the_details_you_have_pr_y_match_those_on_record'),
    accountSwitched: defineMessage('the_details_you_have_pr_and_update_if_necessary_1'),
    noMatch: defineMessage('it_has_not_been_possibl_and_update_if_necessary'),
    providedBeneficiaryDetails: defineMessage('provided_beneficiary_details'),
    suggestedBeneficiaryDetails: defineMessage('suggested_beneficiary_details'),
    name: defineMessage('name'),
    copiedToClipboard: defineMessage('copied_to_clipboard'),
    av100Text: defineMessage('the_beneficiary_details_ing_beneficiary_details'),
    av200Text: defineMessage('the_account_number_and__and_update_if_necessary'),
    av201Text: defineMessage('the_name_you_have_provi_and_update_if_necessary'),
};
